// /src/state.js
export let prevHash = localStorage.getItem("prevHash") || "";
export let lastHash =
  localStorage.getItem("lastHash") || window.location.hash || "";

export function updatePrevHash(h) {
  prevHash = h || "";
  localStorage.setItem("prevHash", prevHash);
}

export function setLastHash(h) {
  lastHash = h || "";
  localStorage.setItem("lastHash", lastHash);
}
